<template>
  <div
    class="day-event"
    :style="defaultStyle"
  >
    <div class="img">
      <i
        v-if="type === 'Holiday'"
        class="hi hi-icon hi-20 hi-time-off"
      />
      <img
        v-else
        :src="avatar"
      />
    </div>
    <div class="event-details">
      <span class="name">{{ userRealName }}</span>
      <span class="event-details">{{ eventDetails }}</span>
    </div>
    <div class="all-day">
      <span v-if="allDay">All day</span>
    </div>
    <div
      v-if="shiftSpillover"
      class="d-flex align-items-center"
    >
      <i
        v-tooltip="{ placement: 'left' }"
        class="hi-right"
        title="This shift continues into the next day"
      />
    </div>
  </div>
</template>

<script>
import SchedulesEventMixin from '~/mixins/attendance_schedules/SchedulesEventMixin';
import { mapInertiaProps } from '~/utils/inertia';

export default {
  name: 'DayViewEvent',
  mixins: [SchedulesEventMixin],
  props: {
    event: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapInertiaProps({
      timeZone: ({ time_zone: timeZone }) => timeZone.for,
    }),
    eventDetails() {
      return this.type === 'Shift' ? `${this.type}: ${this.duration}` : this.type;
    },
  },
};
</script>
